import { $CombinedState } from "redux";
import { stateType } from "../store";
import { State } from "./reducers/initialStates";

type exclude = Exclude<keyof stateType, typeof $CombinedState>;

/**
 * Strips transient payment fields from orderReducer before persisting.
 * `success`, `direct`, and `orderInfo` are ephemeral flags for a single
 * checkout session — they must never survive a page refresh.
 */
const sanitizeState = (state: stateType): stateType => ({
  ...state,
  orderReducer: {
    ...state.orderReducer,
    success: false,
    direct: false,
    orderInfo: null
  }
});

export class StateLoader {
  loadState() {
    try {
      let serializedState = localStorage.getItem("ROOT_STATE");
      let timestamp = localStorage.getItem("ROOT_STATE_TIMESTAMP");

      const ONE_DAY = 24 * 60 * 60 * 1000;
      if (timestamp && (Date.now() - parseInt(timestamp) > ONE_DAY)) {
        localStorage.removeItem("ROOT_STATE");
        localStorage.removeItem("ROOT_STATE_TIMESTAMP");
        return this.initializeState();
      }

      if (serializedState === null) {
        return this.initializeState();
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return this.initializeState();
    }
  }

  saveState(state: stateType, exclude: exclude[] = []) {
    try {
      const sanitized = sanitizeState(state);
      const newState = excludeSave(sanitized, exclude);
      let serializedState = JSON.stringify(newState);
      localStorage.setItem("ROOT_STATE", serializedState);
      localStorage.setItem("ROOT_STATE_TIMESTAMP", Date.now().toString());
    } catch (err) {}
  }

  initializeState() {
    return {
      //state object
    };
  }
}

export const excludeSave = (
  state: stateType,
  exclude: exclude[]
): stateType => {
  const stateCopy = { ...state };
  exclude.forEach((key) => {
    // @ts-ignore
    stateCopy[key] = State[key];
  });
  return stateCopy;
};
